import { FOOTERS } from '../../brands/default/constants';

export const setFooterValue = (show) => (dispatch) => {
  return dispatch({
    show,
    type: FOOTERS.SET_FOOTER,
  });
};
